import React, { useState, useEffect, useCallback, useRef } from 'react';
import { isEmptyChk, toggleLoader, useInstance, translate } from 'utils/common';
import 'assets/sass/main.scss';
import 'assets/sass/product.scss';
import 'assets/sass/contentwrap.scss';
import {
  SHOW_MESSAGE_TO_UI, FILTER_CHANGED, ALL, LIMIT
} from 'utils/constants';
import { getMetaData, getProductList, getProductSuggestions } from 'components/products/product.service';
import Search from 'components/common/search';
import TableWithPagination from 'components/common/table/tablewithpagination';
import DataTable from 'components/common/table/datatable';
import { default as ReactSelect } from "react-select";
import { NoData } from 'common/components';
import { formMetaData, P_ITEMS_LIMIT } from './productSearch.constant';
import Filters from 'components/filters';
import FilterField from 'components/filterfield';  
function Products(props) {
  const { setModalData } = props;
  const { displayName } = props.formProps.formInfo;
  const { formInfo, fullData, maxitems } = props.formProps;
  let uniqueKey = formMetaData[formInfo.formID].uniqueID;

  const language_codeRef = useRef(formInfo ? (formInfo.lang.value ? formInfo.lang.value : fullData[formInfo.lang.formKey]) : 'EN');
  const [currentFilter, setCurrentFilter] = useState({});
  const [currentSearch, setCurrentSearch] = useState({});
  // const [activePage, setActivePage] = useState(1);
  const activePage = useRef(1)
  const [metaData, setMetaData] = useState({});
  const [tableData, setTableData] = useState({ products: [], columnData: [], paginationConfig: {} });
  const [prodPills, setProdPills] = useState(props.formProps.value);
  const prodPillsIDs = useRef(props.formProps.value ? props.formProps.value.map((data) => String(data[uniqueKey])) : []);
  const [instance, setInstance] = useInstance(1);
  useEffect(() => {
    // let ev = {};
    // ev[FILTER_CHANGED] = filterChanged;
    // app.events.subscribe(ev, this);
    getMetaData('group').then(res => {
      let formMetaDataBase = res.data;
      let patchedFormData = formMetaData[formInfo.formID];
      formMetaDataBase = {
        ...formMetaDataBase,
        ...patchedFormData
      }
      setMetaData(formMetaDataBase);
    });
  }, [formInfo.formID]);

  const getData = useCallback(() => {
    if (isEmptyChk(metaData)) return;

    function processColumnData(columnData) {
      columnData && columnData.map((column) => {
        // if (column.dataField == "productInformation") column.formatter = productFormatter;
        // if (column.dataField === 'productStatus') column.formatter = statusFormatter;
        // if (column.dataField === 'originalPrice') column.headerAttrs = { width: 150 };
      });
      return columnData;
    }

    const defaultSearchQuery = () => {
      let resultFieldList = [];
      if (metaData && !isEmptyChk(metaData)) {
        resultFieldList = metaData.searchResultFieldList.map(item => item.dataField)
      }
      return {
        query: {
          ...app.pageParams,
          f: formInfo ?
            formInfo.searchFixedKeys.map((val) => {
              if (val.isCode) {
                return { field: val.key, codes: val.hasOwnProperty('value') ? [val.value] : [fullData[val.formKey]] }
              }
              return { field: val.key, value: val.hasOwnProperty('value') ? val.value : fullData[val.formKey] }
            })
            : [],
          limit: P_ITEMS_LIMIT,
          page: activePage.current,
          searchListMetaInfo: {},
          transformData: false,
          lang: language_codeRef.current,
          predefinedFilter: formInfo.formID.toUpperCase()
          // lang: formInfo ? (formInfo.lang.value ? formInfo.lang.value : fullData[formInfo.lang.formKey]) : 'EN'
        },
        resultFieldList: resultFieldList
      }
    }

    toggleLoader(true);
    // let pageProps = { page: activePage };
    let sq = {
      // ...pageProps,
      tab: ALL,
      ...(!isEmptyChk(currentFilter) ? currentFilter : defaultSearchQuery()),
      ...currentSearch
    };
    sq.query.page = activePage.current;
    let dataSources = [
      getProductList(sq)
    ]
    let sourceOrder = {
      data: 0
    }
    Promise.all(dataSources).then((resData) => {
      let data = resData[sourceOrder.data];
      let processedRowData = data.rowData.map(item => { return { ...item, selected: prodPillsIDs.current.includes(item[uniqueKey]), id: item[uniqueKey] } });
      toggleLoader(false);
      if (data.error) {
        app.events.trigger(SHOW_MESSAGE_TO_UI, { message: data.error, msgType: "error" });
      } else {
        setTableData((prevTableData) => {
          return {
            ...prevTableData,
            rowData: processedRowData,
            columnData: processColumnData(metaData.searchResultFieldList),
            paginationConfig: { page: activePage.current || data.page, totalItemsCount: data.totalItemsCount, itemsPerPage: P_ITEMS_LIMIT },
          }
        })
      }
    }).catch((err) => {
      toggleLoader(false);
      app.events.trigger(SHOW_MESSAGE_TO_UI, { message: 'load_data_fail', msgType: "error" });
    });
  }, [currentFilter, currentSearch, metaData, fullData, formInfo]);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    setTableData((prevTableData) => {
      return {
        ...prevTableData,
        rowData: [],
        columnData: [],
        paginationConfig: {},
        countData: {}
      }
    })
  }, [currentFilter])

  async function getSuggestions(searchValue, searchCategory) {

    let suggestions = [];
    let valueArrForSearchQuery = {}
    if (formInfo && formInfo.searchFixedKeys) {
      formInfo.searchFixedKeys.forEach((key) => {
        valueArrForSearchQuery[key.autoSuggestKey] = key.hasOwnProperty('autoSuggestValue') ? key.autoSuggestValue : fullData[key.formKey]
      });
    }
    let resSuggestions = await getProductSuggestions(searchValue, formInfo.autoSuggestMetaData[searchCategory], valueArrForSearchQuery, language_codeRef.current, fullData)
    resSuggestions = resSuggestions ? resSuggestions.map((data) => {
      return {
        // sap_product_id: data.source.sap_product_id,
        [searchCategory]: data.source[searchCategory],
        id: data.source.o_id,
        cms_id: data.source.o_id,
        display_name: data.source.display_name
      }
    }) : [];
    suggestions = resSuggestions;

    return suggestions
  }

  function handleSearchChange(query) {
    activePage.current = 1; 
    let q = { ...query };
    q[LIMIT] = P_ITEMS_LIMIT;
    q["page"] = 1;
    q.f = formInfo ?
      formInfo.searchFixedKeys.map((val) => {
        if (val.isCode) {
          return { field: val.key, codes: val.hasOwnProperty('value') ? [val.value] : [fullData[val.formKey]] }
        }
        return { field: val.key, value: val.hasOwnProperty('value') ? val.value : fullData[val.formKey] }
      }) : [];
    let sq = {
      query: q,
      resultFieldList: metaData.searchResultFieldList.map(item => item.dataField)
    };
    sq.query.lang = language_codeRef.current;
    // sq.query.lang = formInfo ? (formInfo.lang.value ? formInfo.lang.value : fullData[formInfo.lang.formKey]) : 'EN'
    setCurrentSearch(sq);
     
  }

  function languageChanged(newFilter){
    activePage.current = 1;    
    setInstance();
    // let sq = {...currentSearch};
    language_codeRef.current = newFilter.f[0].codes[0]
    setCurrentSearch((prevSearch)=>{
      return{
        //...prevSearch, query:{...prevSearch.query, lang: language_codeRef.current, page:1}
      }
    }); 
  }

  // function filterChanged([newFilter]) {
  //   setCurrentFilter(newFilter);
  // }

  function updateTableData(updatedData) {
    let selectedItemsIds = updatedData.rowData.filter(item=>item.selected).map(item=>item.id)
    let newSelectedFullIds = selectedItemsIds;
    if(prodPillsIDs.current.length){
      newSelectedFullIds = [...new Set([...selectedItemsIds, ...prodPillsIDs.current])]
      // newSelectedFullIds = [...new Set([...selectedItemsIds, ...props.formProps.value.map((data) => String(data[uniqueKey]))])]
    }
    if(maxitems && maxitems!=-1 && (newSelectedFullIds.length> maxitems)){
      app.events.trigger(SHOW_MESSAGE_TO_UI, { message: translate('maxitemslimitmsg').replace('{0}', maxitems), msgType: "error" });
      setTableData((prevData)=> {
        return {...prevData}
      }) 
    }else{
      setTableData({ ...updatedData });
      addData(updatedData);
    }    
  }
  function handlePageChange(activePageParam) {
    activePage.current = activePageParam;
    getData();
  }

  function onChange(values) {
    values = values || [];
    setProdPills(values);
    setModalData(values);
    prodPillsIDs.current = values.map(pill => String(pill[uniqueKey]));
    let processedRowData = tableData.rowData.map(item => { return { ...item, selected: prodPillsIDs.current.includes(String(item[uniqueKey])) } });
    setTableData((prevTableData) => {
      return {
        ...prevTableData,
        rowData: processedRowData
      }
    });
  }

  const BlankValue = (
  ) => {
    return ''
  };

  function addData(updatedData) {
    setProdPills((prevData) => {
      let newData = [...prevData];
      updatedData.rowData.forEach(dt => {
        if (dt.selected) {
          if (!newData.find(item => item[uniqueKey] == dt[uniqueKey])) {
            newData.push(dt);
          }
        } else {
          if (newData.find(item => item[uniqueKey] == dt[uniqueKey])) {
            newData.splice(newData.findIndex((row) => row[uniqueKey] == dt[uniqueKey]), 1);
          }
        }
      });
      prodPillsIDs.current = newData.map((data) => String(data[uniqueKey]));
      setModalData(newData);
      return newData;
    });
  }

  function getName(option) {
    return option[displayName.mainName] + (option[displayName.subName] ? ` ( ${option[displayName.subName]} )` : '');
  }  

  return (
    <React.Fragment>
      <ReactSelect
        isMulti={true}
        isSearchable={false}
        options={prodPills}
        isClearable={true}
        className="custom-prod-search-multi-select"
        value={prodPills}
        onChange={selected => { return onChange(selected) }}
        classNamePrefix="custom-prod-search-multi-select"
        components={
          {
            Menu: BlankValue,
            DropdownIndicator: BlankValue
          }}
        getOptionLabel={option => getName(option)}
        getOptionValue={option => option.id}
      />
      <div className="manage-products product-search-table-container">
        <React.Fragment>
          {metaData && !isEmptyChk(metaData) && <div className="filter-head mb-0">
            <Search searchCategoryOptions={metaData.searchOptions} onChange={handleSearchChange}
              onSuggestionsFetchRequested={getSuggestions} instance={instance} />

            {props.showLangFilter && <Filters clsNames="ml-3"  filterChanged={languageChanged} >
                <FilterField data={metaData.language_code?metaData.language_code.options:[]} 
                  prependSelectValue={false}
                  field={'lang'} label={translate("Language")} type="cb"
                  defaultValue={"EN"} 
                />
            </Filters>}
          </div>}          

          {!isEmptyChk(tableData.rowData) && !isEmptyChk(tableData.columnData) &&
            (<TableWithPagination pageChange={handlePageChange} hideTopPagination={true}
              paginationConfig={tableData.paginationConfig}>
              <DataTable
                rowSelectEnabled={true}
                tableData={tableData}
                updateTableData={updateTableData}
                disableActionCol={true} />
            </TableWithPagination>)}
          {tableData.rowData && tableData.rowData.length == 0 && <NoData />}
        </React.Fragment>
      </div>
    </React.Fragment>
  )
}
export default Products;
